import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

// Only initialise carousel if the element exists on the page
const carouselEl = document.querySelector(".cards-carousel");
if (carouselEl) {
    new Swiper(carouselEl, {
        modules: [Navigation],
        slidesPerView: 1.5,
        spaceBetween: 8,
        loop: true,
        initialSlide: 2,
        slidesOffsetBefore: 8,
        speed: 1000,
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                slidesOffsetBefore: 16,
                spaceBetween: 16,
            },
        },
        navigation: {
            prevEl: ".prev-card",
            nextEl: ".next-card",
        },
    });
}

const capabilitiesCards = document.querySelectorAll("[data-capabilities-card]");

capabilitiesCards?.forEach((card) => {
    const imagesContainer = card.querySelector(
        ".capabilities-images-container",
    );
    if (!imagesContainer) return;

    const speed = imagesContainer.getAttribute('data-speed');

    const images = imagesContainer.querySelectorAll(".capabilities-image");
    const totalImages = images.length;

    if (totalImages <= 1) return;

    let currentIndex = 0;
    let intervalId = null;
    const flickSpeed = speed || 500; // milliseconds between image changes

    const showImage = (index) => {
        images.forEach((img, i) => {
            img.style.opacity = i === index ? "1" : "0";
        });
    };

    const playOnce = card.hasAttribute("data-capabilities-play-once");

    const startFlicking = () => {
        if (intervalId) return; // Already running

        intervalId = setInterval(() => {
            if (playOnce && currentIndex >= totalImages - 1) {
                clearInterval(intervalId);
                intervalId = null;
                return;
            }
            currentIndex = playOnce ? currentIndex + 1 : (currentIndex + 1) % totalImages;
            showImage(currentIndex);
        }, flickSpeed);
    };

    const stopFlicking = () => {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
        currentIndex = 0;
        showImage(0);
    };

    const isMobile = window.matchMedia("(max-width: 1279px)").matches;
    const isAutoCycle = card.hasAttribute("data-capabilities-auto-cycle");

    if (isMobile || isAutoCycle) {
        if (isAutoCycle) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            startFlicking();
                        } else {
                            stopFlicking();
                        }
                    });
                },
                { threshold: 0.1 }
            );
            observer.observe(card);
        } else {
            startFlicking();
        }
    } else {
        card.addEventListener("mouseenter", startFlicking);
        card.addEventListener("mouseleave", stopFlicking);
    }
});
